const ItemType = require('@/lib/Items/ItemType');

/**
 * Allows for retrieval of an item from the local store by providing an item type and itemID
 * rather than other code having to deal with all the separate repositories.
 */
class ItemRepository {
    /**
     * @param {GiftVoucherRepository} giftVoucherRepository
     * @param {ItemOptionRepository} itemOptionRepository
     * @param {MembershipPlanRepository} membershipPlanRepository
     * @param {ProductRepository} productRepository
     * @param {TicketRepository} ticketRepository
     */
    constructor(
        giftVoucherRepository,
        itemOptionRepository,
        membershipPlanRepository,
        productRepository,
        ticketRepository
    ) {
        this.giftVoucherRepository = giftVoucherRepository;
        this.itemOptionRepository = itemOptionRepository;
        this.membershipPlanRepository = membershipPlanRepository;
        this.productRepository = productRepository;
        this.ticketRepository = ticketRepository;
    }

    /**
     * @param {string} itemType
     * @param {number} itemID
     *
     * @return {Promise}
     */
    getItem(itemType, itemID) {
        switch (itemType) {
            case ItemType.GIFT_VOUCHER:
                return this.giftVoucherRepository.find(itemID);

            case ItemType.ITEM_OPTION:
                return this.itemOptionRepository.find(itemID);

            case ItemType.MEMBERSHIP_PLAN:
                return this.membershipPlanRepository.find(itemID);

            case ItemType.PRODUCT:
            case ItemType.PRODUCT_FOOD:
                return this.productRepository.find(itemID);

            case ItemType.TICKET:
                return this.ticketRepository.find(itemID);
        }

        return Promise.reject(new Error(`Unsupported item type (${itemType}).`));
    }

    /**
     * Sets the 'item' property of each line in the given array of order/cart lines, where that item can be
     * found in the local store.
     *
     * @param {OrderLine[]|CartLine[]} lines
     */
    attachItemsToOrderLines(lines) {
        return Promise.all(
            lines.map((line) => {
                return this.getItem(line.itemType, line.itemID)
                    .then((item) => {
                        line.item = item;

                        // Set the event on the line too (if not already set) while we have it.
                        if (item.event && !line.event) {
                            line.event = item.event;
                        }
                    })
                    .catch(() => {});
            })
        );
    }
}

module.exports = ItemRepository;
